import { Emphases, GROUP_ORDER, RowColors, RowOffsets } from "./consts";
import type {
  GroupName,
  PriceRowSpec,
  PriceRowSpecInput,
  SectionId,
} from "./types";

type DefineRowsDefaults = Partial<
  Pick<PriceRowSpec, "emphasis" | "color" | "offset">
>;

type GroupedRowSpecs = Partial<Record<GroupName, PriceRowSpecInput[]>>;

/**
 * Attaches `section` + `group` to row specs and applies section-level defaults.
 * Group key order follows the canonical `GROUP_ORDER`, not object key order.
 * This is a three layer key merge:
 * 1. Fallbacks - emphasis, color, offset
 * 2. ...defaults: section-level overrides for emphasis, color, offset
 * 3. ...row: per-row fields win over both above,
 * 4. section, group -> these arguments win over the above
 */

const defineRows = (
  section: SectionId,
  groups: GroupedRowSpecs,
  defaults?: DefineRowsDefaults,
): PriceRowSpec[] => {
  return GROUP_ORDER.flatMap((group) => {
    const rows = groups[group] ?? [];
    return rows.map((row) => ({
      emphasis: Emphases.Default,
      color: RowColors.Default,
      offset: RowOffsets.None,
      ...defaults,
      ...row,
      section,
      group,
    }));
  });
};

export type { DefineRowsDefaults, GroupedRowSpecs };
export { defineRows };
